import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { SharedModule, MOMENT_DATE_FORMATS } from '../shared/shared.module';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {
  MAT_DATE_FORMATS,
  DateAdapter,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { SwiperModule } from 'swiper/angular';

import { TrackingComponent } from './tracking.component';
import { TrackingStartComponent } from './tracking-start/tracking-start.component';
import { TrackingItemComponent } from './tracking-item/tracking-item.component';
import { TrackingItemStatusComponent } from './tracking-item/tracking-item-status/tracking-item-status.component';
import { TrackingRoutingModule } from './tracking.routing';
import { TrackingItemSignatureDialog } from './tracking-item/tracking-item-signature-dialog/tracking-item-signature-dialog';
import { TrackingVerifyPhone } from './tracking-verify-phone-dialog/tracking-verify-phone-dialog';
import {TrackingVerifyPhoneRefund} from '../tracking/tracking-item/tracking-verify-phone-refund-dialog/tracking-verify-phone-refund-dialog';
import { TrackingItemPhotoDialog } from './tracking-item/tracking-item-photo-dialog/tracking-item-photo-dialog';
import { TrackingItemProofPhotoDialog } from './tracking-item/tracking-item-proof-photo-dialog/tracking-item-proof-photo-dialog';
import { environment } from 'src/environments/environment';
import { TrackingSearchComponent } from './tracking-search/tracking-search.component';
import { TrackingSearchResolve } from './tracking-search/tracking-search.resolve';
//import { TrackingItemRefundCodPdfPreview } from './tracking-item/tracking-item-refund/tracking-item-refund-cod-preview/tracking-item-refund-cod-preview';
// import {TrackingItemRefundCodConsent } from './tracking-item/tracking-item-refund/tracking-item-refund-cod-consent/tracking-item-refund-cod-consent';
// import {TrackingItemRefundCodDialog } from './tracking-item/tracking-item-refund/tracking-item-refund-cod-dialog/tracking-item-refund-cod-dialog';
@NgModule({
  declarations: [
    TrackingComponent,
    TrackingStartComponent,
    TrackingItemComponent,
    TrackingItemStatusComponent,
    TrackingItemPhotoDialog,
    TrackingItemSignatureDialog,
    TrackingSearchComponent,
    TrackingVerifyPhone,
    TrackingItemProofPhotoDialog,
    TrackingVerifyPhoneRefund,
    //TrackingItemRefundCodPdfPreview,
    // TrackingItemRefundCodConsent,
    // TrackingItemRefundCodDialog
    
  ],
  imports: [
    SharedModule,
    TrackingRoutingModule,
    SwiperModule
    // TranslateModule.forChild({
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: HttpLoaderFactory,
    //     deps: [HttpClient],
    //   },
    // }),
  ],
  bootstrap: [TrackingItemProofPhotoDialog],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [
    TrackingSearchResolve,
    DecimalPipe,
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
  ],
  entryComponents: [TrackingItemSignatureDialog, TrackingItemPhotoDialog],
})
export class TrackingModule {}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, `./assets/i18n/`, '.txt');
}

export interface DialogData {
  data: any;
  isVerify: boolean;
}

export interface NumberInput{
  digit1:number;
  digit2:number;
  digit3:number;
  digit4:number;
}
